import yup from './yup';

const initialValues = {
  name: '',
  phone: '',
  supportId: '',
  consent: false,
  token: '',
};

const validationSchema = yup.object().shape({
  name: yup.string().required('Bitte geben Sie Ihren Namen ein.'),
  phone: yup.string().required('Bitte geben Sie Ihre Telefonnummer ein.').matches(/^[0-9+\s()-]{6,20}$/, 'Bitte geben Sie eine gültige Telefonnummer ein.'),
  supportId: yup.string().required('Bitte geben Sie ihre Sitzungs-ID ein.'),
  consent: yup.bool().oneOf([true], 'Bitte stimmen Sie der Datenverarbeitung zu.'),
  token: yup.string().required('Bitte bestätigen Sie die Captcha Abfrage.'),
});

export default {
  initialValues,
  validationSchema,
};
